import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum OrderTypeIds {
  NEW = 1,
  ADD_ON = 2,
  UPGRADE = 3,
  RENEWAL = 4,
}

export function getOrderTypes(): ISelectItem[] {
  return [
    { id: OrderTypeIds.NEW, label: 'New' },
    { id: OrderTypeIds.ADD_ON, label: 'Add-On' },
    { id: OrderTypeIds.UPGRADE, label: 'Upgrade' },
    { id: OrderTypeIds.RENEWAL, label: 'Renewal' },
  ]
}

export const getOrderTypeByLabel = getItemByLabelFactory(getOrderTypes)
export const getOrderTypeById = getItemByIdFactory(getOrderTypes)
